import { render, staticRenderFns } from "./BuyboxInternationalOffers.vue?vue&type=template&id=1cbc2a7d&scoped=true"
import script from "./BuyboxInternationalOffers.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuyboxInternationalOffers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./BuyboxInternationalOffers.vue?vue&type=style&index=0&id=1cbc2a7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc2a7d",
  null
  
)

export default component.exports